module.exports = __webpack_public_path__ + "static/img/tsl4.042eeb3e.jpg";